// ---- FALL_2025_DATA.2025 아래에 추가 ----
export const FALL_2025_DATA = {
  2025: {
    서울: {
      event: '추계',
      divisions: [
        /* ========== 1부 ========== */
        {
          name: '1부',
          groups: [
            /* --- 1조 (연세/국민/시립/홍익) --- */
            {
              name: '1조',
              teams: [
                '연세대 이글스',
                '국민대 레이저백스',
                '서울시립대 시티혹스',
                '홍익대 카우보이스',
              ],
              matches: [
                {
                  stage: '조별',
                  date: '2025-09-06',
                  location: '서울대학교 대운동장',
                  home: '연세대 이글스',
                  away: '국민대 레이저백스',
                  homeScore: 50,
                  awayScore: 6,
                  winner: '연세대 이글스',
                },
                // 09-13 국민 6–9 홍익 (해마루)
                {
                  stage: '조별',
                  date: '2025-09-13',
                  location: '해마루 축구장',
                  home: '국민대 레이저백스',
                  away: '홍익대 카우보이스',
                  homeScore: 6,
                  awayScore: 9,
                  winner: '홍익대 카우보이스',
                },
                // 09-14 연세 36–16 시립 (서울대 대운동장)
                {
                  stage: '조별',
                  date: '2025-09-14',
                  location: '서울대학교 대운동장',
                  home: '연세대 이글스',
                  away: '서울시립대 시티혹스',
                  homeScore: 36,
                  awayScore: 16,
                  winner: '연세대 이글스',
                },
                // 09-20 국민 0–7 시립 (국민대)
                {
                  stage: '조별',
                  date: '2025-09-20',
                  location: '국민대학교',
                  home: '국민대 레이저백스',
                  away: '서울시립대 시티혹스',
                  homeScore: 0,
                  awayScore: 7,
                  winner: '서울시립대 시티혹스',
                },
                // 09-21 연세 28–14 홍익 (살곶이)
                {
                  stage: '조별',
                  date: '2025-09-21',
                  location: '성동구 살곶이 축구장',
                  home: '연세대 이글스',
                  away: '홍익대 카우보이스',
                  homeScore: 28,
                  awayScore: 14,
                  winner: '연세대 이글스',
                },
                // 09-28 시립 9–6 홍익 (서울대 대운동장)
                {
                  stage: '조별',
                  date: '2025-09-28',
                  location: '서울대학교 대운동장',
                  home: '서울시립대 시티혹스',
                  away: '홍익대 카우보이스',
                  homeScore: 9,
                  awayScore: 6,
                  winner: '서울시립대 시티혹스',
                },
              ],
            },

            /* --- 2조 (서울/한양/한국외대/건국) --- */
            {
              name: '2조',
              teams: [
                '서울대 그린테러스',
                '한양대 라이온스',
                '한국외대 블랙나이츠',
                '건국대 레이징불스',
              ],
              matches: [
                // 09-06 서울 20–27 한양 (서울대 대운동장)
                {
                  stage: '조별',
                  date: '2025-09-06',
                  location: '서울대학교 대운동장',
                  home: '서울대 그린테러스',
                  away: '한양대 라이온스',
                  homeScore: 20,
                  awayScore: 27,
                  winner: '한양대 라이온스',
                },
                // 09-13 한양 28–14 건국 (해마루)
                {
                  stage: '조별',
                  date: '2025-09-13',
                  location: '해마루 축구장',
                  home: '한양대 라이온스',
                  away: '건국대 레이징불스',
                  homeScore: 28,
                  awayScore: 14,
                  winner: '한양대 라이온스',
                },
                // 09-14 서울 62–7 한국외대 (서울대 대운동장)
                {
                  stage: '조별',
                  date: '2025-09-14',
                  location: '서울대학교 대운동장',
                  home: '서울대 그린테러스',
                  away: '한국외대 블랙나이츠',
                  homeScore: 62,
                  awayScore: 7,
                  winner: '서울대 그린테러스',
                },
                // 09-20 서울 10–3 건국 (국민대)
                {
                  stage: '조별',
                  date: '2025-09-20',
                  location: '국민대학교',
                  home: '서울대 그린테러스',
                  away: '건국대 레이징불스',
                  homeScore: 10,
                  awayScore: 3,
                  winner: '서울대 그린테러스',
                },
                // 09-21 한양 1–0 한국외대 (기권·몰수로 표기 1–0)
                {
                  stage: '조별',
                  date: '2025-09-21',
                  location: '성동구 살곶이 축구장',
                  home: '한양대 라이온스',
                  away: '한국외대 블랙나이츠',
                  homeScore: 1,
                  awayScore: 0,
                  winner: '한양대 라이온스',
                },
                // 09-28 한국외대 2–0 건국 (표기 2–0)
                {
                  stage: '조별',
                  date: '2025-09-28',
                  location: '서울대학교 대운동장',
                  home: '한국외대 블랙나이츠',
                  away: '건국대 레이징불스',
                  homeScore: 2,
                  awayScore: 0,
                  winner: '한국외대 블랙나이츠',
                },
              ],
            },
          ],
          final: [
            {
              stage: '결승전',
              date: '2025-10-04',
              location: '효창운동장',
              home: '연세대 이글스',
              away: '한양대 라이온스',
              homeScore: 40,
              awayScore: 3,
              winner: '연세대 이글스',
            },
          ],
          playoffs: [
            {
              stage: '3,4위전',
              date: '2025-10-04',
              location: '효창운동장',
              home: '서울대 그린테러스',
              away: '서울시립대 시티혹스',
              homeScore: 14,
              awayScore: 3,
              winner: '서울대 그린테러스',
            },
            {
              stage: '5,6위전',
              date: '2025-10-04',
              location: '효창운동장',
              home: '홍익대 카우보이스',
              away: '한국외대 블랙나이츠',
              homeScore: 3,
              awayScore: 6,
              winner: '한국외대 블랙나이츠',
            },
            {
              stage: '7,8위전',
              date: '2025-10-11',
              location: '해마루 축구장',
              home: '건국대 레이징불스',
              away: '국민대 레이저백스',
              homeScore: 26,
              awayScore: 13,
              winner: '건국대 레이징불스',
            },
          ],
          promotion: [
            {
              stage: '승강전',
              date: '2025-11-09',
              location: '효창운동장',
              home: '홍익대 카우보이스',
              away: '고려대 타이거스',
              homeScore: 12,
              awayScore: 22,
              winner: '고려대 타이거스',
            },
          ],
        },

        /* ========== 2부 ========== */
        {
          name: '2부',
          groups: [
            // 2부 1조: 고려/중앙/경희
            {
              name: '1조',
              teams: [
                '고려대 타이거스',
                '중앙대 블루드래곤스',
                '경희대 커맨더스',
              ],
              matches: [
                // 09-06 고려 33–14 중앙
                {
                  stage: '조별',
                  date: '2025-09-06',
                  location: '서울대학교 대운동장',
                  home: '고려대 타이거스',
                  away: '중앙대 블루드래곤스',
                  homeScore: 33,
                  awayScore: 14,
                  winner: '고려대 타이거스',
                },
                // 09-14 중앙 26–6 경희
                {
                  stage: '조별',
                  date: '2025-09-14',
                  location: '해마루 축구장',
                  home: '중앙대 블루드래곤스',
                  away: '경희대 커맨더스',
                  homeScore: 26,
                  awayScore: 6,
                  winner: '중앙대 블루드래곤스',
                },
                // 09-20 고려 37–6 경희
                {
                  stage: '조별',
                  date: '2025-09-20',
                  location: '국민대학교',
                  home: '고려대 타이거스',
                  away: '경희대 커맨더스',
                  homeScore: 37,
                  awayScore: 6,
                  winner: '고려대 타이거스',
                },
              ],
            },
            // 2부 2조: 동국/숭실/서강
            {
              name: '2조',
              teams: [
                '동국대 터스커스',
                '숭실대 크루세이더스',
                '서강대 알바트로스',
              ],
              matches: [
                // 09-13 동국 0–26 숭실
                {
                  stage: '조별',
                  date: '2025-09-13',
                  location: '해마루 축구장',
                  home: '동국대 터스커스',
                  away: '숭실대 크루세이더스',
                  homeScore: 0,
                  awayScore: 26,
                  winner: '숭실대 크루세이더스',
                },
                // 09-21 숭실 21–20 서강
                {
                  stage: '조별',
                  date: '2025-09-21',
                  location: '성동구 살곶이 축구장',
                  home: '숭실대 크루세이더스',
                  away: '서강대 알바트로스',
                  homeScore: 21,
                  awayScore: 20,
                  winner: '숭실대 크루세이더스',
                },
                // 09-28 동국 7–17 서강
                {
                  stage: '조별',
                  date: '2025-09-28',
                  location: '서울대학교 대운동장',
                  home: '동국대 터스커스',
                  away: '서강대 알바트로스',
                  homeScore: 7,
                  awayScore: 17,
                  winner: '서강대 알바트로스',
                },
              ],
            },
          ],
          final: [
            {
              stage: '결승전',
              date: '2025-10-03',
              location: '효창운동장',
              home: '고려대 타이거스',
              away: '숭실대 크루세이더스',
              homeScore: 16,
              awayScore: 0,
              winner: '고려대 타이거스',
            },
          ],
          playoffs: [
            {
              stage: '3,4위전',
              date: '2025-10-03',
              location: '효창운동장',
              home: '서강대 알바트로스',
              away: '중앙대 블루드래곤스',
              homeScore: 0,
              awayScore: 8,
              winner: '중앙대 블루드래곤스',
            },
            {
              stage: '5,6위전',
              date: '2025-10-03',
              location: '효창운동장',
              home: '동국대 터스커스',
              away: '경희대 커맨더스',
              homeScore: 6,
              awayScore: 14,
              winner: '경희대 커맨더스',
            },
          ],
          promotion: [
            {
              stage: '승강전',
              date: '2025-11-09',
              location: '효창운동장',
              home: '홍익대 카우보이스',
              away: '고려대 타이거스',
              homeScore: 12,
              awayScore: 22,
              winner: '고려대 타이거스',
            },
          ],
        },
      ],
    },
    경기강원: {
      event: '추계',
      divisions: [
        {
          name: '1부',
          groups: [
            {
              name: '리그',
              teams: [
                '성균관대 로얄스',
                '강원대 카프라',
                '단국대 코디악베어스',
                '인하대 틸 드래곤스',
              ],
              matches: [
                {
                  stage: '조별',
                  date: '2025-08-30',
                  location: '미정',
                  home: '성균관대 로얄스',
                  away: '인하대 틸 드래곤스',
                  homeScore: 36,
                  awayScore: 16,
                  winner: '성균관대 로얄스',
                },
                {
                  stage: '조별',
                  date: '2025-08-31',
                  location: '미정',
                  home: '단국대 코디악베어스',
                  away: '강원대 카프라',
                  homeScore: 13,
                  awayScore: 20,
                  winner: '강원대 카프라',
                },
                {
                  stage: '조별',
                  date: '2025-09-13',
                  location: '미정',
                  home: '성균관대 로얄스',
                  away: '단국대 코디악베어스',
                  homeScore: 29,
                  awayScore: 0,
                  winner: '성균관대 로얄스',
                },
                {
                  stage: '조별',
                  date: '2025-09-14',
                  location: '미정',
                  home: '강원대 카프라',
                  away: '인하대 틸 드래곤스',
                  homeScore: 27,
                  awayScore: 34,
                  winner: '인하대 틸 드래곤스',
                },
                {
                  stage: '조별',
                  date: '2025-09-27',
                  location: '미정',
                  home: '성균관대 로얄스',
                  away: '강원대 카프라',
                  homeScore: 12,
                  awayScore: 10,
                  winner: '성균관대 로얄스',
                },
                {
                  stage: '조별',
                  date: '2025-09-28',
                  location: '미정',
                  home: '단국대 코디악베어스',
                  away: '인하대 틸 드래곤스',
                  homeScore: 0,
                  awayScore: 0,
                  winner: '무승부',
                },
              ],
            },
          ],
        },
        {
          name: '2부',
          groups: [
            {
              name: '리그',
              teams: [
                '한신대 킬러웨일스',
                '한림대 피닉스',
                '카이스트 매버릭스',
                '용인대 화이트타이거스',
              ],
              matches: [
                {
                  stage: '조별',
                  date: '2025-08-30',
                  location: '미정',
                  home: '한신대 킬러웨일스',
                  away: '용인대 화이트타이거스',
                  homeScore: 0,
                  awayScore: 58,
                  winner: '용인대 화이트타이거스',
                },
                {
                  stage: '조별',
                  date: '2025-08-31',
                  location: '미정',
                  home: '한림대 피닉스',
                  away: '카이스트 매버릭스',
                  homeScore: 20,
                  awayScore: 0,
                  winner: '한림대 피닉스',
                },
                {
                  stage: '조별',
                  date: '2025-09-13',
                  location: '미정',
                  home: '카이스트 매버릭스',
                  away: '한신대 킬러웨일스',
                  homeScore: 7,
                  awayScore: 9,
                  winner: '한신대 킬러웨일스',
                },
                {
                  stage: '조별',
                  date: '2025-09-14',
                  location: '미정',
                  home: '용인대 화이트타이거스',
                  away: '한림대 피닉스',
                  homeScore: 0,
                  awayScore: 0,
                  winner: '무승부',
                },
                {
                  stage: '조별',
                  date: '2025-09-27',
                  location: '미정',
                  home: '카이스트 매버릭스',
                  away: '용인대 화이트타이거스',
                  homeScore: 0,
                  awayScore: 0,
                  winner: '무승부',
                },
                {
                  stage: '조별',
                  date: '2025-09-28',
                  location: '미정',
                  home: '한신대 킬러웨일스',
                  away: '한림대 피닉스',
                  homeScore: 0,
                  awayScore: 0,
                  winner: '무승부',
                },
              ],
            },
          ],
        },
      ],
    }, // :contentReference[oaicite:16]{index=16}

    부산경남: {
      event: '추계',
      divisions: [
        {
          name: '1부',
          groups: [
            {
              name: '리그',
              teams: [
                '경성대 드래곤스',
                '동아대 레오파즈',
                '동의대 터틀파이터스',
                '울산대 유니콘스',
              ],
              matches: [
                {
                  stage: '조별',
                  date: '2025-09-13',
                  location: '철마체육공원',
                  home: '경성대 드래곤스',
                  away: '울산대 유니콘스',
                  homeScore: 64,
                  awayScore: 14,
                  winner: '경성대 드래곤스',
                }, // :contentReference[oaicite:4]{index=4}
                {
                  stage: '조별',
                  date: '2025-09-13',
                  location: '철마체육공원',
                  home: '동아대 레오파즈',
                  away: '동의대 터틀파이터스',
                  homeScore: 14,
                  awayScore: 19,
                  winner: '동의대 터틀파이터스',
                }, // :contentReference[oaicite:5]{index=5}
                {
                  stage: '조별',
                  date: '2025-09-28',
                  location: '철마체육공원',
                  home: '울산대 유니콘스',
                  away: '동아대 레오파즈',
                  homeScore: 0,
                  awayScore: 0,
                  winner: '무승부',
                }, // :contentReference[oaicite:6]{index=6}
                {
                  stage: '조별',
                  date: '2025-09-28',
                  location: '철마체육공원',
                  home: '경성대 드래곤스',
                  away: '동의대 터틀파이터스',
                  homeScore: 22,
                  awayScore: 8,
                  winner: '경성대 드래곤스',
                }, // :contentReference[oaicite:7]{index=7}
              ],
            },
          ],
        },
        {
          name: '2부',
          groups: [
            {
              name: '리그',
              teams: [
                '동서대 블루돌핀스',
                '한신라대 데빌스',
                '부산외국어대 토네이도',
                '한국해양대 바이킹스',
                '부산대 이글스',
              ],
              matches: [
                {
                  stage: '조별',
                  date: '2025-09-06',
                  location: '옹촌체육공원',
                  home: '동서대 블루돌핀스',
                  away: '한신라대 데빌스',
                  homeScore: 12,
                  awayScore: 39,
                  winner: '한신라대 데빌스',
                }, // :contentReference[oaicite:8]{index=8}
                {
                  stage: '조별',
                  date: '2025-09-06',
                  location: '옹촌체육공원',
                  home: '부산외국어대 토네이도',
                  away: '한국해양대 바이킹스',
                  homeScore: 28,
                  awayScore: 18,
                  winner: '부산외국어대 토네이도',
                }, // :contentReference[oaicite:9]{index=9}
                {
                  stage: '조별',
                  date: '2025-09-14',
                  location: '옹촌체육공원',
                  home: '부산대 이글스',
                  away: '동서대 블루돌핀스',
                  homeScore: 28,
                  awayScore: 0,
                  winner: '부산대 이글스',
                }, // :contentReference[oaicite:10]{index=10}
                {
                  stage: '조별',
                  date: '2025-09-14',
                  location: '옹촌체육공원',
                  home: '한국해양대 바이킹스',
                  away: '한신라대 데빌스',
                  homeScore: 0,
                  awayScore: 0,
                  winner: '무승부',
                }, // :contentReference[oaicite:11]{index=11}
                {
                  stage: '조별',
                  date: '2025-09-20',
                  location: '철마체육공원',
                  home: '한신라대 데빌스',
                  away: '부산대 이글스',
                  homeScore: 13,
                  awayScore: 34,
                  winner: '부산대 이글스',
                }, // :contentReference[oaicite:12]{index=12}
                {
                  stage: '조별',
                  date: '2025-09-20',
                  location: '철마체육공원',
                  home: '부산외국어대 토네이도',
                  away: '동서대 블루돌핀스',
                  homeScore: 0,
                  awayScore: 0,
                  winner: '무승부',
                }, // :contentReference[oaicite:13]{index=13}
                {
                  stage: '조별',
                  date: '2025-09-27',
                  location: '옹촌체육공원',
                  home: '부산외국어대 토네이도',
                  away: '한신라대 데빌스',
                  homeScore: 33,
                  awayScore: 0,
                  winner: '부산외국어대 토네이도',
                }, // :contentReference[oaicite:14]{index=14}
                {
                  stage: '조별',
                  date: '2025-09-27',
                  location: '옹촌체육공원',
                  home: '부산대 이글스',
                  away: '한국해양대 바이킹스',
                  homeScore: 16,
                  awayScore: 10,
                  winner: '부산대 이글스',
                }, // :contentReference[oaicite:15]{index=15}
              ],
            },
          ],
        },
      ],
    },

    대구경북: {
      event: '추계',
      divisions: [
        {
          name: '1부',
          groups: [
            {
              name: '리그',
              teams: [
                '한동대 홀리램스',
                '경북대 오렌지파이터스',
                '경일대 블랙베어스',
                '대구가톨릭대 스커드엔젤스',
                '대구한의대 라이노스',
              ],
              matches: [
                {
                  stage: '조별',
                  date: '2025-09-06',
                  location: '군위종합운동장',
                  home: '한동대 홀리램스',
                  away: '대구한의대 라이노스',
                  homeScore: 7,
                  awayScore: 0,
                  winner: '한동대 홀리램스',
                },
                {
                  stage: '조별',
                  date: '2025-09-06',
                  location: '군위종합운동장',
                  home: '경북대 오렌지파이터스',
                  away: '경일대 블랙베어스',
                  homeScore: 46,
                  awayScore: 0,
                  winner: '경북대 오렌지파이터스',
                },
                {
                  stage: '조별',
                  date: '2025-09-13',
                  location: '경일대 블랙베어스',
                  home: '한동대 홀리램스',
                  away: '대구가톨릭대 스커드엔젤스',
                  homeScore: 0,
                  awayScore: 8,
                  winner: '대구가톨릭대 스커드엔젤스',
                },
                {
                  stage: '조별',
                  date: '2025-09-13',
                  location: '경일대 블랙베어스',
                  home: '경일대 블랙베어스',
                  away: '대구한의대 라이노스',
                  homeScore: 13,
                  awayScore: 2,
                  winner: '경일대 블랙베어스',
                },
                {
                  stage: '조별',
                  date: '2025-09-21',
                  location: '대구한의대 라이노스',
                  home: '한동대 홀리램스',
                  away: '경북대 오렌지파이터스',
                  homeScore: 0,
                  awayScore: 42,
                  winner: '경북대 오렌지파이터스',
                },
                {
                  stage: '조별',
                  date: '2025-09-21',
                  location: '대구한의대 라이노스',
                  home: '대구한의대 라이노스',
                  away: '대구가톨릭대 스커드엔젤스',
                  homeScore: 6,
                  awayScore: 12,
                  winner: '대구가톨릭대 스커드엔젤스',
                },
                {
                  stage: '조별',
                  date: '2025-09-28',
                  location: '대구가톨릭대 스커드엔젤스',
                  home: '경북대 오렌지파이터스',
                  away: '대구한의대 라이노스',
                  homeScore: 0,
                  awayScore: 0,
                  winner: '무승부',
                },
                {
                  stage: '조별',
                  date: '2025-09-28',
                  location: '대구가톨릭대 스커드엔젤스',
                  home: '대구가톨릭대 스커드엔젤스',
                  away: '경일대 블랙베어스',
                  homeScore: 0,
                  awayScore: 0,
                  winner: '무승부',
                },
              ],
            },
          ],
        },
        {
          name: '2부',
          groups: [
            {
              name: '리그',
              teams: [
                '영남대 페가수스',
                '계명대 슈퍼라이온스',
                '금오공과대 레이븐스',
                '대구대 플라잉타이거스',
                '동국대 화이트엘리펀츠',
              ],
              matches: [
                {
                  stage: '조별',
                  date: '2025-09-07',
                  location: '군위종합운동장',
                  home: '영남대 페가수스',
                  away: '계명대 슈퍼라이온스',
                  homeScore: 28,
                  awayScore: 0,
                  winner: '영남대 페가수스',
                },
                {
                  stage: '조별',
                  date: '2025-09-07',
                  location: '군위종합운동장',
                  home: '금오공과대 레이븐스',
                  away: '대구대 플라잉타이거스',
                  homeScore: 36,
                  awayScore: 14,
                  winner: '금오공과대 레이븐스',
                },
                {
                  stage: '조별',
                  date: '2025-09-14',
                  location: '대구대 플라잉타이거스',
                  home: '금오공과대 레이븐스',
                  away: '동국대 화이트엘리펀츠',
                  homeScore: 18,
                  awayScore: 0,
                  winner: '금오공과대 레이븐스',
                },
                {
                  stage: '조별',
                  date: '2025-09-14',
                  location: '대구대 플라잉타이거스',
                  home: '대구대 플라잉타이거스',
                  away: '계명대 슈퍼라이온스',
                  homeScore: 18,
                  awayScore: 0,
                  winner: '대구대 플라잉타이거스',
                },
                {
                  stage: '조별',
                  date: '2025-09-20',
                  location: '군위종합운동장',
                  home: '영남대 페가수스',
                  away: '대구대 플라잉타이거스',
                  homeScore: 6,
                  awayScore: 14,
                  winner: '대구대 플라잉타이거스',
                },
                {
                  stage: '조별',
                  date: '2025-09-20',
                  location: '군위종합운동장',
                  home: '동국대 화이트엘리펀츠',
                  away: '계명대 슈퍼라이온스',
                  homeScore: 1,
                  awayScore: 0,
                  winner: '동국대 화이트엘리펀츠',
                },
                {
                  stage: '조별',
                  date: '2025-09-27',
                  location: '계명대 슈퍼라이온스',
                  home: '영남대 페가수스',
                  away: '동국대 화이트엘리펀츠',
                  homeScore: 0,
                  awayScore: 0,
                  winner: '무승부',
                },
                {
                  stage: '조별',
                  date: '2025-09-27',
                  location: '계명대 슈퍼라이온스',
                  home: '계명대 슈퍼라이온스',
                  away: '금오공과대 레이븐스',
                  homeScore: 0,
                  awayScore: 20,
                  winner: '금오공과대 레이븐스',
                },
              ],
            },
          ],
        },
      ],
    }, // :contentReference[oaicite:17]{index=17}

    사회인: {
      event: '추계', // KNFL 시즌
      divisions: [
        {
          name: '정규',
          groups: [
            {
              name: '전체',
              teams: [
                '인천 라이노스',
                '군위 피닉스',
                '부산 그리폰즈',
                '서울 골든이글스',
                '삼성 블루스톰',
                '서울 바이킹스',
                '서울 디펜더스',
              ],
              matches: [
                {
                  stage: '조별',
                  date: '2025-05-18',
                  location: '군위종합운동장',
                  home: '인천 라이노스',
                  away: '군위 피닉스',
                  homeScore: 0,
                  awayScore: 26,
                  winner: '군위 피닉스',
                },
                {
                  stage: '조별',
                  date: '2025-05-18',
                  location: '군위종합운동장',
                  home: '부산 그리폰즈',
                  away: '서울 골든이글스',
                  homeScore: 10,
                  awayScore: 14,
                  winner: '서울 골든이글스',
                },
                {
                  stage: '조별',
                  date: '2025-06-01',
                  location: '군위종합운동장',
                  home: '삼성 블루스톰',
                  away: '서울 바이킹스',
                  homeScore: 27,
                  awayScore: 3,
                  winner: '삼성 블루스톰',
                },
                {
                  stage: '조별',
                  date: '2025-06-01',
                  location: '군위종합운동장',
                  home: '서울 골든이글스',
                  away: '서울 디펜더스',
                  homeScore: 20,
                  awayScore: 3,
                  winner: '서울 골든이글스',
                },
                {
                  stage: '조별',
                  date: '2025-06-15',
                  location: '군위종합운동장',
                  home: '부산 그리폰즈',
                  away: '서울 디펜더스',
                  homeScore: 36,
                  awayScore: 13,
                  winner: '부산 그리폰즈',
                },
                {
                  stage: '조별',
                  date: '2025-06-15',
                  location: '군위종합운동장',
                  home: '삼성 블루스톰',
                  away: '군위 피닉스',
                  homeScore: 23,
                  awayScore: 13,
                  winner: '삼성 블루스톰',
                },
                {
                  stage: '조별',
                  date: '2025-06-29',
                  location: '군위종합운동장',
                  home: '인천 라이노스',
                  away: '서울 골든이글스',
                  homeScore: 20,
                  awayScore: 19,
                  winner: '인천 라이노스',
                },
                {
                  stage: '조별',
                  date: '2025-06-29',
                  location: '군위종합운동장',
                  home: '군위 피닉스',
                  away: '서울 디펜더스',
                  homeScore: 19,
                  awayScore: 0,
                  winner: '군위 피닉스',
                },
                {
                  stage: '조별',
                  date: '2025-08-31',
                  location: '군위종합운동장',
                  home: '삼성 블루스톰',
                  away: '서울 디펜더스',
                  homeScore: 14,
                  awayScore: 0,
                  winner: '삼성 블루스톰',
                },
                {
                  stage: '조별',
                  date: '2025-08-31',
                  location: '군위종합운동장',
                  home: '인천 라이노스',
                  away: '부산 그리폰즈',
                  homeScore: 15,
                  awayScore: 30,
                  winner: '부산 그리폰즈',
                },
                {
                  stage: '조별',
                  date: '2025-09-14',
                  location: '군위종합운동장',
                  home: '군위 피닉스',
                  away: '서울 바이킹스',
                  homeScore: 21,
                  awayScore: 20,
                  winner: '군위 피닉스',
                },
                {
                  stage: '조별',
                  date: '2025-09-14',
                  location: '군위종합운동장',
                  home: '인천 라이노스',
                  away: '서울 디펜더스',
                  homeScore: 15,
                  awayScore: 19,
                  winner: '서울 디펜더스',
                },
                {
                  stage: '조별',
                  date: '2025-09-28',
                  location: '군위종합운동장',
                  home: '삼성 블루스톰',
                  away: '인천 라이노스',
                  homeScore: 6,
                  awayScore: 6,
                  winner: '무승부',
                },
                {
                  stage: '조별',
                  date: '2025-09-28',
                  location: '군위종합운동장',
                  home: '부산 그리폰즈',
                  away: '서울 바이킹스',
                  homeScore: 35,
                  awayScore: 13,
                  winner: '부산 그리폰즈',
                },
                {
                  stage: '조별',
                  date: '2025-10-12',
                  location: '군위종합운동장',
                  home: '서울 바이킹스',
                  away: '서울 디펜더스',
                  homeScore: 9,
                  awayScore: 21,
                  winner: '서울 디펜더스',
                },
                {
                  stage: '조별',
                  date: '2025-10-12',
                  location: '군위종합운동장',
                  home: '삼성 블루스톰',
                  away: '서울 골든이글스',
                  homeScore: 21,
                  awayScore: 14,
                  winner: '삼성 블루스톰',
                },
                {
                  stage: '조별',
                  date: '2025-10-26',
                  location: '군위종합운동장',
                  home: '군위 피닉스',
                  away: '부산 그리폰즈',
                  homeScore: 21,
                  awayScore: 6,
                  winner: '군위 피닉스',
                },
                {
                  stage: '조별',
                  date: '2025-10-26',
                  location: '군위종합운동장',
                  home: '인천 라이노스',
                  away: '서울 바이킹스',
                  homeScore: 12,
                  awayScore: 13,
                  winner: '서울 바이킹스',
                },
                {
                  stage: '조별',
                  date: '2025-11-09',
                  location: '군위종합운동장',
                  home: '삼성 블루스톰',
                  away: '부산 그리폰즈',
                  homeScore: 18,
                  awayScore: 0,
                  winner: '삼성 블루스톰',
                },
                {
                  stage: '조별',
                  date: '2025-11-09',
                  location: '군위종합운동장',
                  home: '서울 골든이글스',
                  away: '서울 바이킹스',
                  homeScore: 9,
                  awayScore: 21,
                  winner: '서울 바이킹스',
                },
                {
                  stage: '조별',
                  date: '2025-11-23',
                  location: '군위종합운동장',
                  home: '군위 피닉스',
                  away: '서울 골든이글스',
                  homeScore: 22,
                  awayScore: 7,
                  winner: '군위 피닉스',
                },
              ],
            },
          ],
          final: [
            {
              stage: '결승전',
              date: '2025-12-14',
              location: '군위종합운동장',
              home: '삼성 블루스톰',
              away: '군위 피닉스',
              homeScore: 37,
              awayScore: 21,
              winner: '삼성 블루스톰',
            },
          ],
        },
      ],
    }, // :contentReference[oaicite:18]{index=18}
  },
};
